import classNames from 'classnames'

import { ICON_HEIGHT_8, IconNG } from '../../Icon'

import * as styles from './TextareaPlaceholder.module.css'

import Asterisk from '../../../icons/asterisk.svg'

function TextareaPlaceholder({
  boxClassName,
  className,
  placeholder,
  ref,
  required,
}) {
  const placeholderClassName = classNames(styles.placeholder, className)

  const placeholderBoxClasName = classNames(
    styles.placeholderBox,
    {
      [styles.required]: required,
    },
    boxClassName
  )

  return (
    <div className={placeholderBoxClasName} ref={ref}>
      <span className={placeholderClassName}>{placeholder}</span>
      {required ? (
        <IconNG
          Icon={Asterisk}
          className={styles.requiredIcon}
          size={ICON_HEIGHT_8}
        />
      ) : null}
    </div>
  )
}

export default TextareaPlaceholder
